import { useAuth, useCart } from '@chordcommerce/gatsby-theme-autonomy'
import { addTagsToOrder, removeTagsFromOrder } from '~/services/chord/client'
import { getDoesCartHaveBulkItems } from '~/utils/bulk'
import { TAGS } from '~/utils/lists/order-tags'

export function useOrderTags() {
  const { token } = useAuth()
  const { cart } = useCart()

  const { lineItems, tagList } = cart

  const addTags = async (tags) => await addTagsToOrder(token, cart, tags)

  const removeTags = async (tags) =>
    await removeTagsFromOrder(token, cart, tags)

  const updateBulkDtcTag = async () => {
    const hasBulkItems = getDoesCartHaveBulkItems(lineItems)
    const hasBulkTag = tagList.includes(TAGS.BULK_DTC)

    if (!hasBulkTag && hasBulkItems) {
      return await addTags({ tags: [TAGS.BULK_DTC, TAGS.BULK_DTC_STORE] })
    } else if (hasBulkTag && !hasBulkItems) {
      return await removeTags({ tags: [TAGS.BULK_DTC] })
    }
  }

  return {
    addTags,
    removeTags,
    TAGS,
    updateBulkDtcTag,
  }
}
